<template>
  <!-- 右边的全集原料 -->

  <div class="table" style="padding: 10px">
    <a-row type="flex" align="middle" justify="space-between" style="margin-bottom: 10px">
      <h3>
        全集原料
        <a-tag v-if="selectedRowKeys.length > 0">已选中 {{ selectedRowKeys.length }} 原料</a-tag>
      </h3>

      <a-space>
        <a-button type="primary" @click="synchronizePrices" :disabled="selectedRowKeys.length == 0">同步最新价格</a-button>
        <a-button @click="toggleSilo" :loading="toggleSiloBtnLoading"
          :disabled="selectedRowKeys.length == 0 || selectedRowKeys.length > 10">料仓分配</a-button>
        <a-button @click="toggleHasAnalyse" :disabled="selectedRowKeys.length !== 1">梯度分析</a-button>
        <a-select placeholder="所有原料" style="width: 100px" v-model="rawCurrentType">
          <a-select-option :key="index" :value="index" v-for="(item, index) in rawTypes">{{ item }}</a-select-option>
        </a-select>
      </a-space>
    </a-row>

    <!-- @change="getList" -->
    <resize-table bordered :scroll="{ x: 500, y: height }" tableName="taskRawColumns" :columns="taskRawColumns"
      :loading="rawListLoading" :data-source="list.records" :row-key="(record) => record.id" :pagination="pagination"
      :rowClassName="rowClassname" :row-selection="{
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps,
      }" @change="changePage">
      <span slot="customTitle"><a-icon @click="fixedCol" type="pushpin" :theme="filled ? 'filled' : 'outlined'" />
        原料名称</span>
      <div slot="rawName" slot-scope="text, item" style="display: flex;">
        <template v-if="item.status === 1">
          <img style="width: 26px; position: absolute; top: 0; left: 0" src="@/assets/images/shixiao.svg" />
          <div style="width: 14px"></div>
        </template>
        <a-tooltip size="small">
          <a-row type="flex" align="middle" justify="space-between" v-if="item.isRawDelete == 1">
            <span style="flex: 1; padding: 4px 2px">{{
              overseasFlag == "1" ? item.aliasName || text : text
            }}</span>
            <a-button v-if="item.isExtraProRaw != 1 || item.isDeleted != 1" type="link" size="small" icon="delete"
              @click="deleteRaw(item)" />
          </a-row>
          <span v-else-if="item.isExtraProRaw == 1 && item.isDeleted == 1">
            {{ overseasFlag == "1" ? item.aliasName || text : text }}
          </span>
          <a v-else @click="toggleTaskRaw(item)">
            {{ overseasFlag == "1" ? item.aliasName || text : text }}
          </a>
          <template slot="title">{{
            item.isRawDelete == 1
              ? "原料已删除"
              : "点击查看原料在不同配方中的用量"
          }}</template>
        </a-tooltip>
      </div>
      <!-- <template v-for="(col) in ['maxValue', 'minValue']" slot-scope="text" :slot="col">
        {{text|numberFixed(3)}}
      </template> -->
      <template slot="fixed3" slot-scope="t">{{
        t || t === 0 || t === "0" ? Number(t).toFixed(3) : ""
      }}</template>
      <template v-for="(col, index) in ['rawPrice', 'minValue', 'maxValue']" slot-scope="text, record" :slot="col">
        <span v-if="
          record.isRawDelete == 1 ||
          (record.isExtraProRaw == 1 && record.isDeleted == 1)
        " :key="col">
          {{ text | numberFixed(3) }}
        </span>
        <cell-editor v-else :key="index" :slot="col" slot-scope="text, record" :len="3" :item="record" :name="col"
          @blur="(target) => itemUpdate(target, record.id)" :text="text" :actions="update" />
      </template>
      <span slot="diffUasge" slot-scope="text" :class="{ red: text > 0, green: text < 0 }">
        <a-icon v-if="text !== '' || text !== null || text !== 0" :type="text > 0 ? 'arror-up' : 'arror-down'" />
        {{
          text == "" || text == null || text == 0
            ? "-"
            : Number(text).toFixed(3)
        }}
      </span>
      <span v-for="el in ['uasge', 'productRawUasge']" :slot="el" slot-scope="text" :key="el">
        {{ text | numberFixed(3) }}
      </span>
    </resize-table>

    <silo-drawer :visible="siloDrawerVisible" :selected-rows="selectedRows" :task-id="taskId" :task-name="taskName"
      @close="siloDrawerVisible = false">
    </silo-drawer>
  </div>
</template>

<script>
// 用量（%）= 最大值和极上限时，最大值、极上限显示为红色；用量（%）= 最小值和极下限时，最小值、极下限显示为绿色
import { formulaMixins } from '../unitls';
import CellEditor from './CellEditor.vue';
import SiloDrawer from '../drawer/SiloDrawer.vue';
export default {
  mixins: [formulaMixins],
  components: { CellEditor, SiloDrawer },
  data() {
    return {
      taskName: '',
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      rawCurrentType: 0,
      itemVisible: false,
      rawVisible: false,
      rawListLoading: false,
      filterData: {},
      currentValue: null,
      priceValues: '',
      rawValue: 0,
      list: {
        records: []
      },
      cacheData: [],
      priceVal: ['privateContractPrice', 'privatePredictionPrice', 'privateStockPrice', 'privateMarketPrice'],
      selectedRowKeys: [],
      selectedRows: [],
      filled: true,

      siloDrawerVisible: false,
      toggleSiloBtnLoading: false,
    };
  },
  mounted() {
    this.getList({ pageSize: 100, current: 1 });
  },
  watch: {
    async rawCurrentType(val) {
      let list = JSON.parse(JSON.stringify(this.cacheData));
      if (list && list.length) {
        if (val == 0) this.list.records = list;
        if (val == 1) this.list.records = list.filter(i => i.uasge > 0);
        if (val == 2) this.list.records = list.filter(i => i.uasge == 0);
        this.pagination.current = 1;
        this.pagination.total = this.list.records.length;
      }
    },
    resRaw(val) {
      if (val) this.getList(this.pagination);
    },
    selectedRows(rawRows) {
      this.setState({ rawSelect: rawRows[0], rawRows });
    },
  },
  methods: {
    changeColumns() {
      let taskRawColumns = [...this.taskRawColumns];
      if (this.filled) {
        taskRawColumns[0].fixed = 'left';
      } else {
        delete taskRawColumns[0].fixed;
      }
      this.setState({ taskRawColumns });
    },
    fixedCol(e) {
      this.filled = !this.filled;
      this.changeColumns();
      e = e || window.event;
      if (e.stopPropagation) { //W3C阻止冒泡方法
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    // 料仓分配
    toggleSilo() {
      const data = {
        "rawIdList": this.selectedRows.map(item => item.rawId),
        "taskId": this.taskId
      };
      this.toggleSiloBtnLoading = true;
      this.$post('/nhf-app/formulaRemoteCal/checkTaskSilo', data).then(res => {
        if (res.success) {
          if (res.data.formulaSolutionType == 0) {
            this.$error({
              title: '料仓分配操作失败',
              content: `原料在配方中有维护最小值，无法进行料仓分配：${res.data.msg}`,
            });
          } else {
            this.siloDrawerVisible = true;
          }
        }
        this.toggleSiloBtnLoading = false;
      });

    },
    toggleHasAnalyse() {
      this.selectedRows.length > 1
        ? this.$message.warn("只能选中一个原料")
        : this.$emit("toggleHasAnalyse", this.selectedRows);
    },
    synchronizePrices() {
      let rawIdList = this.selectedRows.map(el => el.rawId);
      this.$confirm({
        title: '同步最新价格',
        content: '确定将原料管理中的原料价格更新到多配方中吗？',
        cancelText: '取消',
        okText: '确定',
        onOk: async () => {
          await this.fetchPost({
            actions: this.batchUpdateFormulaTaskRawPrice,
            loading: 'resLoading',
            data: {
              rawIdList,
              taskId: this.taskId,
            }
          });
          this.getList({ pageSize: 100, current: 1 });
        },
        onCancel() { },
      });
    },
    getCheckboxProps(record) {
      let { isExtraProRaw, isDeleted, isRawDelete } = record || {};
      return ({
        props: {
          disabled: isRawDelete == 1 || (isExtraProRaw == 1 && isDeleted == 1),
        }
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      let arr = [...this.selectedRows, ...selectedRows];
      this.selectedRows = selectedRowKeys.map((i) => {
        return arr.filter((item) => item.id === i)[0];
      });
    },
    async deleteRaw(item) {
      await this.fetchPost({
        actions: this.deleteFormulaTaskRawById,
        data: {
          taskId: this.taskId,
          id: item.id
        }
      });
      this.getList(this.pagination);
    },
    rowClassname(record) {
      const { taskRaw } = this;
      let { id: rowId } = taskRaw || {};
      let { id, isRawDelete, uasge, isDeleted, isExtraProRaw } = record || {};
      let className = '';
      if (rowId == id) {
        className = 'selectRows-sel';
      } else {
        if (uasge == 0) className = 'selectRows';
        if (isRawDelete == '1' || (isExtraProRaw == '1' && isDeleted == 1)) className = 'selectGary';
      }
      // return rowId == id ? 'selectRows-sel' : isRawDelete == '1' ? 'selectGary' : (record.uasge == 0 ? 'selectRows' : '')
      return className;
    },
    itemUpdate(item, id) {
      const newData = [...this.list.records];
      const newCacheData = [...this.cacheData];
      const targets = newData.filter(item => id === item.id)[0];
      const targetCache = newCacheData.filter(item => id === item.id)[0];
      if (targets) {
        Object.assign(targetCache, item);
        Object.assign(targets, item);
        this.cacheData = newCacheData;
        this.list.records = newData;
      }
    },

    update(params, name) {
      // let {rawPrice,rawId} = params
      // 原料价格 与 极值 最值 区别
      const isPirce = name == 'rawPrice';
      // const data = isPirce ? {factoryId:this.factoryId,price:rawPrice,rawId,priceSource:this.detail.priceSource} : params
      const data = params;
      if (isPirce) params.priceSource = this.detail.priceSource;
      let { rawName, ...newData } = data || {};
      console.log(rawName);
      return this.fetchPost({
        actions: isPirce ? this.updateFactoryStaffRawPrice : this.updateSingleFormulaTaskRaw,
        showMessage: false,
        data: newData
      }).then(() => {
        if (isPirce) this.$emit('updatePrice');
      });
    },

    toggleTaskRaw(taskRaw) {
      this.toggleVisible('taskRaw');
      this.setState({
        taskRaw
      });
    },
    changePage(arg) {
      let { current = 1, pageSize = 20 } = arg || {};
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
    },
    async getList(arg = {}) {
      this.list.records = [];
      // this.rawCurrentType = 0
      let { pageSize = 20, current = 1 } = arg || this.pagination;
      const res = await this.fetchGet({
        loading: 'rawListLoading',
        name: 'list',
        actions: this.selectFormulaTaskRawAllPage,
        isList: true,
        data: {
          taskId: this.taskId,
          // size: pageSize,
          size: 10000,
          current,
        }
      });
      if (res && res.data && res.data.records) {
        this.cleanSelect();
        res.data.records = res.data.records.filter(el => !(el.isRawDelete == 0 && el.isDeleted == 1 && el.isExtraProRaw == 0));
        res.data.records = res.data.records.filter(el => !(el.isRawDelete == 1 && el.isDeleted == 1 && el.isExtraProRaw == 0));
        this.list = res.data;
        this.cacheData = JSON.parse(JSON.stringify(res.data.records));
        this.$emit('setList', { field: 'materialList', list: this.cacheData });
      }
      this.pagination.pageSize = pageSize;
      return res;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .selectGary {
  background-color: rgba(130, 130, 130, 0.1) !important;
}

::v-deep .selectRows {
  background-color: rgba(255, 206, 163, 0.1) !important;
  background-color: #fff9e5 !important;
}

h3 {
  margin: 0;
}

.red {
  color: red;
}

.green {
  color: green;
}

::v-deep .selectRows-sel {
  background-color: rgba(86, 204, 242, 0.2);
}
</style>
